import styled from "styled-components";

export const VouchersSwiperBackgroundBox = styled.div`
    width: 100%;
    background: linear-gradient(rgba(23, 23, 23, 0.5),rgba(0, 0, 0, 0.5)), url(${(props) => props.theme.images.freePlay.backgroundVouchersSlider.toString()});
    background-repeat: no-repeat;
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        background: linear-gradient(rgba(23, 23, 23, 0.5),rgba(0, 0, 0, 0.5)), url(${(props) => props.theme.images.freePlay.backgroundVouchersSlider.toString()}) 0 -44px;
        background-size: cover;
    }
`;
